import React from "react"

export default ({ className }) => (
    <div className={`list-group-item-thumb shadow ${className || ""}`} />
)
